import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/jquery.showhtml.js";
import "LIBS/jquery.validate.js";
import "LIBS/jquery.validate.unobtrusive.js";
import accessibilityUtil from 'HSNDIR/AccessibilityUtility.js';

/**
    * class HSN.Modal
    *
    * Encapsulates the functionality of a modal dialog that contains product information.
    **/
HSN.Modal = (function () {
    Modal.prototype.disabled = false;
    Modal.prototype.elementToFocusOnClose = null;

    Modal.EVENT =
    {
        MODAL_OPEN: 'HSN.Modal.EVENT.MODAL_OPEN',
        MODAL_CLOSE: 'HSN.Modal.EVENT.MODAL_CLOSE',
    }
        
    function Modal(className) {
        /**
            * new HSN.Modal()
            **/
        var __scope = this;

        if (!Modernizr.touchevents)
            $(window).resize(function () {
                __scope.Center();

            });

        $(window).on('keydown', function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode != 27) {
                return;
            }
            __scope.Hide();
        });

        $(window).scroll(function () {
            $('#modal-mask').css('height', $('body').height());
        });

        this.Root = className ? $('<div class="modal ' + className + '"></div>') : $('<div class="modal"></div>');
        this.Root.hide();

        var ariaFirst = "<div id=\"modalPopup\" role=\"presentation\" aria-modal=\"true\" aria-label=\"Dialog opened\" tabindex=\"0\" class=\"visuallyhidden\">Dialog opened</div>";
        this.Root.append(ariaFirst);

        this.Close = $('<a href="#" id="closeModal" tabindex="0" class="close" aria-label="close dialog"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" viewBox="0 0 512 512"><defs><path id="a" d="M0 511.756h511.756V.001H0v511.755z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path class="bg-color" fill="#0077c8" d="M366.86 335.774l-31.112 31.112-79.87-79.87-79.871 79.87-31.113-31.112 79.87-79.87-79.915-79.916 31.114-31.113 79.915 79.916 79.916-79.916 31.112 31.113-79.916 79.915 79.87 79.871zM74.858 74.86c-99.81 99.811-99.81 262.227 0 362.038 99.811 99.812 262.228 99.812 362.04 0 99.81-99.81 99.81-262.227 0-362.038-99.813-99.81-262.228-99.81-362.04 0z" mask="url(#b)"/></g></svg></a>');
        this.Close.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if(__scope.elementToFocusOnClose) {
                __scope.elementToFocusOnClose.focus();
            }
            __scope.Hide();
        });
        this.Close.on('keyup', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var keys = accessibilityUtil.GetKeys();
            var key = e.keyCode || e.which;
            if(key === keys.enter) {
                if(__scope.elementToFocusOnClose) {
                    __scope.elementToFocusOnClose.focus();
                }
                __scope.Hide();
            }
        });

        this.Root.append(this.Close);

        this.Content = $('<div class="modal-content-container" tabindex="0"></div>');
        this.Root.append(this.Content);

        this._initialize();


        //TODO ugh, specifics in here, needed by potentially multiple modals, create another object to inherit from
        this.Content.on('click', '#login-nickname-wrapper .nickname-continue', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var form = $('#login-nickname-wrapper form', __scope.Content);

            //manually run client validation since we arent running submit operation
            if (!form.valid())
                return;

            $.ajax({
                type: 'POST',
                url: '/nickname?' + new Date().getTime(),
                dataType: 'html',
                contentType: 'application/x-www-form-urlencoded',
                data: form.serialize()
            })
                .done(function (data) {
                    //TODO: fix this event so that we actually no it was added and not just submitted and maybe added
                    HSN.Instance().Events.Trigger(HSN.Application.EVENT.NICKNAME_ADDED);

                    if (data.length == 0) {
                        __scope.Hide();
                        return;
                    }
                    __scope.Content.showHtml(data, 0,
                        function () {
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 });
                            //needed for unobtrusive client side validation for ajax loaded form
                            $.validator.unobtrusive.parse(form);
                        },
                        function () {
                            //__scope.Center();
                        });
                })
                .fail(function () {
                    alert('error submitting review');
                });
        });
        this.Content.on('click', '#login-nickname-wrapper .nickname-cancel', function (e) {
            e.preventDefault();
            e.stopPropagation();

            __scope.Hide();
        });
    }

    Modal.prototype._initialize = function () {
    };

    // This private method must be implemented by all HSN.Modal subclasses.
    Modal.prototype._show = function () {
        throw "_show() is not implemented in " + this.constructor.name;
    };
    Modal.prototype.Root = null;
    Modal.prototype.Banner = null;


    /**
        * HSN.Modal#Content -> jQuery
        *
        * [[HSN.Modal#Content]] provides access to the jQuery-wrapped HTML element that contains the content for the modal.
        **/
    Modal.prototype.Content = null;

    /**
        * HSN.Modal#Root -> jQuery
        *
        * [[HSN.Modal#Content]] provides access to the jQuery-wrapped HTML element that is the root of the modal.
        **/
    Modal.prototype.Root = null;

    Modal.prototype.SetBanner = null;

    Modal.prototype.Disable = function() {
        this.disabled = true;

        if (this.Root != null)
            this.Hide();
    }

    Modal.prototype.Enable = function () {
        this.disabled = false;
    }


    /**
        * HSN.Modal#Center() -> void
        *
        * Centers the modal on the screen.
        **/
    Modal.prototype.Center = function(topoffset, leftoffset) {
        // TODO: Make window an injected dependency.

        // Move dialog to the left edge of the window, so content resizes root correctly, ensuring width is calculated correctly.
        this.Root.css("left", "0");

        if(!topoffset)
            topoffset = 0;

        if(!leftoffset)
            leftoffset = 0;

        var top = (($(window).height() - this.Root.outerHeight()) / 2);

        var newtop = 0;
        if(top < 0)
            newtop = 61 + $(window).scrollTop() + topoffset;
        else
            newtop = top + $(window).scrollTop() + topoffset;

        this.Root.css({
            top : newtop + "px",
            left : (($('body').width() - this.Root.outerWidth()) / 2) + $(window).scrollLeft() + leftoffset + "px"
        });
        if(!this.Banner) {
            return;
        }
        this.Banner.css({
            top : (this.Root.offset().top - (this.Banner.outerHeight() - parseInt(this.Banner.css("padding-bottom"))) - 14),
            left : this.Root.offset().left
        });
    };

    /**
        * HSN.Modal#Hide() -> void
        *
        * Hides the modal.
        **/
    Modal.prototype.Hide = function () {
        var __scope = this;

        if (!__scope.Root.is(':visible')) {
            return;
        }

        if (__scope.Banner) {
            __scope.Banner.hide();
        }

        if ("_hide" in __scope) {
            __scope._hide();
        }

        this.Content.showHtml(
            '',
            0,
            function () {
                __scope.Root.hide();
            },
            function () {
                //__scope.Center();
            }
        );

        var areAnyModalsOpen = false;
        $('.modal-content-container').each(function() {
            var childrenArray = $(this).children();

            if(typeof childrenArray !== 'undefined' && childrenArray != null && childrenArray.length > 0) {
                areAnyModalsOpen = true;
            }
        });
        if (!areAnyModalsOpen) {
            $('#modal-mask').remove();
        }

        HSN.Instance().Events.Trigger(HSN.Modal.EVENT.MODAL_CLOSE);
    };

    /**
        * HSN.Modal#Show() -> void
        *
        * Shows the modal.
        **/
    Modal.prototype.Show = function () {
        if(this.disabled)
            return;

        this.Content.css('opacity', 0);
        this.Root.addClass('loading');
        this.Content.empty();
        this.Center();
        this.Root.show();
        if (!$('#modal-mask').is(':visible')) {
            $('<div></div>').prependTo('body').attr('id', 'modal-mask');
        }

        if (!$('.modal').hasClass('no-mask') && !$('#modal-mask').is(':visible')) {
            $('#modal-mask').css('height', $('body').height());
            //$('#modal-mask').css('width', $('body').outerWidth());
            $('#modal-mask').show();
        }
        this._show.apply(this, arguments);

        HSN.Instance().Events.Trigger(HSN.Modal.EVENT.MODAL_OPEN);
    };


    Modal.prototype.Refresh = function () {
        this.Root.addClass('loading');
        if (!$('#modal-mask').is(':visible')) {
            $('<div></div>').prependTo('body').attr('id', 'modal-mask');
        }

        if (!$('.modal').hasClass('no-mask') && !$('#modal-mask').is(':visible')) {
            $('#modal-mask').css('height', $('body').height());
            $('#modal-mask').show();
        }
        this._show.apply(this, arguments);
    };
    Modal.prototype.AddLoadingSpinner = function () {
        if (!this.Root.find('#modal-loading').length > 0) {
            this.Root.append('<div id="modal-loading" class="spinner-positioner-relative"><div class="spinner-container small"><div id="floatingCircles48"><div class="f_circle48" id="frotate48_01"></div><div class="f_circle48" id="frotate48_02"></div><div class="f_circle48" id="frotate48_03"></div><div class="f_circle48" id="frotate48_04"></div><div class="f_circle48" id="frotate48_05"></div><div class="f_circle48" id="frotate48_06"></div><div class="f_circle48" id="frotate48_07"></div><div class="f_circle48" id="frotate48_08"></div></div></div></div></div>');
            this.Center();
        }
    };
    Modal.prototype.RemoveLoadingSpinner = function () {
        this.Root.find('#modal-loading, .animated-loader').remove();
        this.Root.removeClass('loading');
    }
    Modal.prototype.SetBanner = function (id) {
        var banner = this.Content.find(id);
        if (this.Banner)
            this.Banner.remove();
        if (banner) {
            this.Banner = banner;
            this.Root.before(banner);

            // Keep originals in data
            var bannerH = banner.children('h6');
            banner.data("originalClass", banner.attr("class"));
            bannerH.data("originalText", bannerH.text());

            banner.css({
                "top": (this.Root.offset().top - (banner.outerHeight() - parseInt(banner.css("padding-bottom"))) - 14),
                "left": this.Root.offset().left,
                "position": "absolute",
                "width": this.Content.outerWidth() - parseInt(banner.css("paddingLeft")) - parseInt(banner.css("paddingRight")) + 2
            });
        }
    };

    Modal.prototype.SetElementToFocusOnClose = function (element) {
        this.elementToFocusOnClose = element;
    };

    //Use to set focus inside modal for ADA
    Modal.prototype.SetFocus = function (element) {
        element.focus();
    };

    return Modal;
})();



// WEBPACK FOOTER //
// ./assets/js/HSN/Modal.js